// extracted by mini-css-extract-plugin
export default {"container":"RbacManagement_container__kgpCv","title":"RbacManagement_title__ghrbG"};